import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n";
import { copy } from "../siteContent";
import PrivacyDialog from "./PrivacyDialog";

export default function SiteFooter() {
  const { language } = useLanguage();
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const t = copy[language];

  return (
    <>
      <footer className="site-footer" id="contact">
        <div className="footer-shell">
          <div className="footer-brand-block">
            <Link className="brand brand-footer" to="/">
              <span className="brand-mark" aria-hidden="true"><span>P</span><i /></span>
              <span className="brand-name">PK-FORENSICS</span>
            </Link>
            <p>{t.footer.statement}</p>
          </div>
          <div className="footer-column">
            <p className="footer-heading">{t.footer.navigation}</p>
            <Link to="/#services">{t.nav.services}</Link>
            <Link to="/#projects">{t.nav.work}</Link>
            <Link to="/#cases">{t.nav.cases}</Link>
            <Link to="/ytvidcreator">YTVidCreator</Link>
            <Link to="/ytvidcreator/tietosuoja">{t.footer.ytVidPrivacy}</Link>
          </div>
          <div className="footer-column footer-contact">
            <p className="footer-heading">{t.footer.contact}</p>
            <a href="mailto:jarmo@pk-forensics.fi">
              jarmo@pk-forensics.fi <ArrowUpRight size={15} />
            </a>
            <a href="tel:+358503279741">+358 50 327 9741</a>
            <span>{t.footer.businessId}</span>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} PK-Forensics. {t.footer.rights}</span>
          <button type="button" onClick={() => setPrivacyOpen(true)}>{t.footer.privacy}</button>
        </div>
      </footer>
      <PrivacyDialog open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </>
  );
}
